
<div class="so-data" v-disable-component="occurrence.isCompleted || !userCanEdit">
  <div v-if="occurrence.type === occType.TechnicalOccurrence">
    <TechnicalOccurrenceData :occurrence="occurrence"></TechnicalOccurrenceData>
  </div>

  <div v-if="occurrence.type === occType.Comat">
    <ComatData :occurrence="occurrence"></ComatData>
  </div>

  <div v-if="occurrence.type === occType.Diversion">
    <DiversionData :occurrence="occurrence"></DiversionData>
  </div>

  <div v-if="occurrence.type === occType.MaterialRequest">
    <MaterialRequestData ref="materialRequestdata" :id="occurrence.id"></MaterialRequestData>
  </div>
</div>
